import { render, staticRenderFns } from "./TwitchStreamModal.vue?vue&type=template&id=665718b7&"
import script from "./TwitchStreamModal.vue?vue&type=script&lang=js&"
export * from "./TwitchStreamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports